import {
  calendarDateInTimezone,
  calendarDateToUtcMidnight,
  DEFAULT_PAYMENT_TERMS_DAYS,
  MILLISECONDS_PER_DAY,
} from '@trellis/shared'

import { useOrganization, useOrganizationToday } from './useOrganization'

/**
 * Returns the organisation's default payment terms (days after issue date), falling back
 * to {@link DEFAULT_PAYMENT_TERMS_DAYS}.
 */
export function usePaymentTermsDefault(): number {
  const { data: organizationResult } = useOrganization()
  return organizationResult?.data?.paymentTermsDays ?? DEFAULT_PAYMENT_TERMS_DAYS
}

/**
 * Returns the default `yyyy-MM-dd` due/expiry date for pre-filling new document forms:
 * `issueDate` (or today, in the org's timezone) plus the org's payment-terms days. Adding
 * days in UTC is safe here since `issueDate` is already a calendar date, not an instant.
 */
export function useDefaultDueDate(issueDate?: string): string {
  const paymentTermsDays = usePaymentTermsDefault()
  const organizationToday = useOrganizationToday()
  const baseDate = issueDate || organizationToday
  const dueDate = new Date(
    calendarDateToUtcMidnight(baseDate).getTime() +
      paymentTermsDays * MILLISECONDS_PER_DAY,
  )
  return calendarDateInTimezone(dueDate, 'UTC')
}
